import { type UUID } from '~/types/common';

import { emptyDeliveryNoteFilterGroup } from './emptyDeliveryNoteFilterGroup';

const createFilters = (
  isEmptyFilterGroup: boolean,
  filterValues: Record<string, any>,
) => {
  const keys = Object.keys(emptyDeliveryNoteFilterGroup);

  const filters = {};
  for (const key of keys) {
    filters[key] = isEmptyFilterGroup ? [] : filterValues[key];
  }

  return filters;
};

/**
 * Returns a filter group object based on the provided parameters.
 *
 * @param {string} filterGroupId - The ID of the filter group.
 * @param {string} filterGroupName - The name of the filter group.
 * @param {Array} filterGroups - The list of filter groups.
 * @param {Array} [filterRows=[]] - The list of filter rows.
 * @param {Object} filterValues - The values of the filters.
 * @param {boolean} isEmptyFilterGroup - Indicates if the filter group is empty.
 * @return {Object} The filter group object.
 */
export const getFilterGroupObject = ({
  filterGroupId,
  filterGroupName,
  filterGroups,
  filterRows = [],
  filterValues,
  isEmptyFilterGroup,
}: {
  filterGroupId: UUID;
  filterGroupName: string;
  filterGroups: Array<Record<string, any>>;
  filterRows: Array<Record<string, any>>;
  filterValues: Record<string, any>;
  isEmptyFilterGroup: boolean;
}) => {
  const filterGroup = filterGroups?.find(({ id }) => id === filterGroupId);

  let newFilterRows = [...filterRows];

  /*
   * If no filter rows, but a filter group have been provided,
   * take the filter rows from the filter group.
   */
  if (newFilterRows.length === 0 && filterGroup) {
    newFilterRows = Array.isArray(filterGroup.filterRows)
      ? [...filterGroup.filterRows]
      : [];
  }

  const filterGroupObject = {
    filterRows: newFilterRows,
    filters: createFilters(isEmptyFilterGroup, filterValues),
    id: filterGroupId,
    name: filterGroupName ?? filterGroup?.name, // filterGroups are not yet set when initializing DeliveryOverview.
  };

  return filterGroupObject;
};
